import React, { useMemo } from "react";
import { Fade } from "react-awesome-reveal";
import Button from "../elements/Button";
import { useProducts } from "../lib/useProducts";

function pickRandom(items, count) {
  const shuffled = [...items].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

export default function FeaturedProducts() {
  const { products, isLoading } = useProducts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const featured = useMemo(() => pickRandom(products, 6), [products.length]);

  return (
    <section className="container mx-auto px-4 py-16">
      <Fade direction="up" triggerOnce>
        <p className="mb-2 text-center text-sm font-semibold uppercase tracking-widest text-gold-700">
          Best Sellers
        </p>
        <h2 className="font-display text-center text-4xl text-maroon-900 sm:text-5xl">
          Some of Our Products
        </h2>
        <p className="mx-auto mb-12 mt-3 max-w-xl text-center text-lg font-light text-slate-500">
          A sneak peek into our best-selling sauces and condiments.
        </p>
      </Fade>

      {isLoading ? (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-72 animate-pulse rounded-2xl bg-slate-100" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((item, index) => (
            <Fade direction="up" triggerOnce delay={100 * index} key={item.id}>
              <div className="group overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
                <div className="relative h-64 w-full bg-slate-50">
                  {item.image_url ? (
                    <img
                      src={item.image_url}
                      alt={item.title}
                      loading="lazy"
                      className="h-full w-full object-contain p-4 transition-transform duration-500 group-hover:scale-105"
                    />
                  ) : (
                    <div className="flex h-full items-center justify-center text-sm text-slate-300">
                      No image yet
                    </div>
                  )}
                </div>
                <div className="border-t border-slate-100 p-4">
                  <h3 className="text-center font-semibold text-slate-800">{item.title}</h3>
                  <p className="mt-1 text-center text-sm text-slate-400">{item.type}</p>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      )}

      <Fade direction="up" triggerOnce>
        <div className="mt-14 flex justify-center">
          <Button
            href="/product"
            type="link"
            className="group flex items-center gap-2 rounded-full border-2 border-maroon-200 px-8 py-3 text-lg font-medium text-maroon-700 transition-colors hover:border-maroon-700 hover:bg-maroon-700 hover:text-white"
          >
            See All Products
            <svg
              className="h-5 w-5 transition-transform group-hover:translate-x-1"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Button>
        </div>
      </Fade>
    </section>
  );
}
